import { Injectable, TemplateRef } from '@angular/core';
import { Subject } from 'rxjs';
import { FlyInModalArgs, ModalArgs, ModalMessage, ModalStates } from '../models/modal';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  alertModalToggle: Subject<ModalArgs> = new Subject();
  confirmModalToggle: Subject<ModalArgs> = new Subject();
  confirmModalCallback: Subject<boolean> = new Subject();
  flyInModalToggle: Subject<FlyInModalArgs> = new Subject();

  constructor() {}

  public showAlertModal(
    message: string | ModalMessage,
    modalState: ModalStates,
    routeCommands?: any,
    header?: string,
    okBtnText?: string,
    hideOkButton?: boolean
  ) {
    const args = new ModalArgs(
      typeof message === 'string' ? new ModalMessage(message, false) : message,
      modalState,
      routeCommands,
      undefined,
      okBtnText || 'Close',
      header
    );
    if (hideOkButton != null) {
      args.HideOkButton = hideOkButton;
    }
    this.alertModalToggle.next(args);
  }

  public showConfirmModal(
    message: string | ModalMessage,
    cancelText?: string,
    confirmText?: string,
    headerText?: string
  ) {
    const args = new ModalArgs(
      typeof message === 'string' ? new ModalMessage(message, false) : message,
      undefined,
      null,
      cancelText,
      confirmText,
      headerText,
      undefined
    );
    this.confirmModalToggle.next(args);
  }

  public showFlyInModal(header: string, content: TemplateRef<any>) {
    this.flyInModalToggle.next(new FlyInModalArgs(header, content));
  }
}
